// Named Battle (not BattleResult) to avoid colliding with the BattleResult component.
export class Battle {
  constructor(raw) {
    this.id = raw.id ?? null;
    this.sceneImageKey = raw.sceneImageKey ?? null;
    this.draw = raw.draw ?? false;
    this.winner = raw.winner ?? {};
    this.whyWinner = raw.whyWinner;
    this.scenePrompt = raw.scenePrompt;
    this.narration = raw.narration ?? [];
    this.character1 = raw.character1 ?? {};
    this.character2 = raw.character2 ?? {};
  }

  static fromJSON(raw) {
    return raw ? new Battle(raw) : null;
  }

  get isDraw() {
    return this.draw === true || String(this.winner?.name ?? "").trim().toLowerCase() === "draw";
  }

  // true/false if characterName is the winner/loser, null for a draw (neither).
  isWinner(characterName) {
    if (!characterName || !this.winner?.name) return false;
    if (this.isDraw) return null;
    const a = characterName.toLowerCase().trim();
    const b = this.winner.name.toLowerCase().trim();
    return a === b || a.includes(b) || b.includes(a);
  }
}
